import React, { useState } from 'react'
import Navbar from '../../components/Navbar/Navbar'
import { Button, Form, Input, Modal, Table, Row } from 'antd'
import { useNavigate } from 'react-router-dom'
import { DeleteOutlined, EditOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import { usePostRequest } from '../../hooks/usePostRequest'
import { UseGetRequest } from '../../utils/api/ApiRequests'
import moment from 'moment'


const AddSubmitButton = ({ form, isLoading }) => {
  const [submittable, setSubmittable] = useState(false);
  
  // Watch all values
  const values = Form.useWatch([], form);
    React.useEffect(() => {
      form.validateFields({
        validateOnly: true,
      }).then(() => {
        setSubmittable(true);
      },
      () => {
        setSubmittable(false);
      },
      );
    }, [values]);
    return (
    <Button type="primary" htmlType="submit" disabled={!submittable} loading={isLoading}>Submit</Button>
    );
};


export default function EvaluationForm() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const {callPost, isLoading} = usePostRequest(()=>{
    // setShowAddModal(false); 
    // setShowEditModal(false);
    setShowViewModal(false);
    form.resetFields();
    setFilterConfig((prev) => ({...prev, is_updated: !prev.is_updated}))});
  // const [showAddModal, setShowAddModal] = useState(false);
  // const [showEditModal, setShowEditModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [clickedRowData, setClickedRowData] = useState({});
  // const [initialValues, setInitialValues] = useState({});
  const [tableData, setTableData] = useState([]);
  const [modal, contextHolder] = Modal.useModal();
  const [filterConfig, setFilterConfig] = useState({
    is_updated: false
  });
  const [isFetching, setIsFetching] = useState(false);
  
  const tableColumns = [
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
    },
    {
      title: 'Date Created',
      dataIndex: 'added_on',
      key: 'added_on',
      render: (added_on) => (
        <div>{moment(added_on).format('MMM DD, YYYY')}</div>
      )
    },
    {
      title: 'Deadline',
      dataIndex: 'deadline',
      key: 'deadline',
      render: (deadline) => (
        <div>{moment(deadline).format('MMM DD, YYYY')}</div>
      )
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    },
  ];

  const confirmDelete = (form) => {
    modal.confirm({
      title: `Are you sure you want to delete form "${form.name}"?`,
      icon: <ExclamationCircleOutlined />,
      content: 'You cannot undo this action.',
      okText: 'Delete',
      cancelText: 'Cancel',
      onOk: ()=>handleDelete(form.id),
      okType: 'danger',
    });
  };

  // const onFinish = (formInputs) => {
  //   // var values = Object.entries(formInputs).map(([key, value]) => ({ key, value }));
  //   callPost(
  //     "forms/add", 
  //     formInputs,
  //     false
  //   );
  // };

  // const onEdit = (formInputs) => {
  //   // var values = Object.entries(formInputs).map(([key, value]) => ({ key, value }));
  //   callPost(
  //     `forms/update/${initialValues.id}`, 
  //     formInputs,
  //     false
  //   );
  // };

  const handleSearch = (e) => {
    setFilterConfig((prev) => ({...prev, term: e}));
  }

  function handleDelete(passedId) {
    callPost("forms/delete/" + passedId,  {}, false);
  }

  const handleRowClick = (rowData) => {
    setClickedRowData(rowData);
    form.setFieldsValue(rowData);
    // setInitialValues(()=>{return{...rowData}});
    setShowViewModal(true);
  };

  const rowProps = (record) => ({
    onClick: () => handleRowClick(record),
  });

//   useEffect(() => {
//     form.setFieldsValue(initialValues);        
// }, [initialValues]);



React.useEffect(() => {
  async function fetchTableData  () {
    setIsFetching(true);
    setTableData([]);
    const response = await UseGetRequest("forms/get", filterConfig);
    if (response.data) {
        setTableData(response.data.data);
    }
    setIsFetching(false);
  }

    fetchTableData ();
}, [filterConfig]);


  return (
    <Navbar pageTitle="Evaluation Forms" pageButtonTitle="Add Evaluation Form" setSearchQuery={handleSearch} onClickButton={()=>navigate("form-page", {state: {add: true}})} isManager searchable>
        <Table className='mt-4' rowKey="id"
          onRow={(record) => ({
            ...rowProps(record), style: { cursor: 'pointer' },
          })} 
          columns={tableColumns} 
          dataSource={tableData} 
          loading={isFetching || isLoading} />

        <Modal
          title="Review Evaluation Form"
          centered
          open={showViewModal}
          footer={null}
          onCancel={() => {
            setShowViewModal(false); 
            form.resetFields();
          }}
        >
          <Form className='mt-3 mx-3' form={form} name="editForm" layout='vertical'>
            <Form.Item
                name="name"
                label="Name"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
              <Input disabled/>
            </Form.Item>
          
            <Form.Item>
              <Row className='d-flex justify-content-end'>
                  <Button danger onClick={()=>setShowViewModal(false)} disabled={isLoading}>Cancel</Button>
                  <Button type="text" onClick={()=>navigate("form-page", {state: {add: false}})} icon={<EditOutlined/>}>Edit</Button>
                  <Button type="text" danger onClick={()=>{confirmDelete(clickedRowData)}} icon={<DeleteOutlined/>}>Delete</Button>
              </Row>
            </Form.Item>
          </Form>
        </Modal>
        {contextHolder}
    </Navbar>
  )
}